import React, { useState } from 'react';
import { ClickElement, InputField } from '../form';
import styles from './DateNavigator.css';
import { MENU } from '../../lib/labels';

const checkDate = field => {
  const minDate = new Date(MENU.FIRST_POST); // 20 march 2006
  const passedDate = field.split('-');
  const FormatedPassedDate = new Date(`${passedDate[2]}-${passedDate[1]}-${passedDate[0]}`);
  const maxDate = new Date();

  if (FormatedPassedDate !== 'Invalid Date' && FormatedPassedDate >= minDate && FormatedPassedDate <= maxDate) {
    return ({ passed: true });
  } else {
    let error = MENU.DATE_NAVIGATOR.ERROR_MESSAGES.DEFAULT;
    const pattern = /^\d{2}-\d{2}-\d{4}$/;
   
    if (pattern.test(field)) {
      if (String(FormatedPassedDate) === 'Invalid Date') {
        error = MENU.DATE_NAVIGATOR.ERROR_MESSAGES.INVALID_DATE;
      }
      if (FormatedPassedDate < minDate) {
        error = MENU.DATE_NAVIGATOR.ERROR_MESSAGES.MIN_DATE;
      }
      if (FormatedPassedDate > maxDate) {
        error = MENU.DATE_NAVIGATOR.ERROR_MESSAGES.MAX_DATE;
      }
    } else {
      error = MENU.DATE_NAVIGATOR.ERROR_MESSAGES.INVALID_DATE;
    }
    return ({ message: error });
  }
};

export const DateNavigator = ({ onSubmit }) => {

  const [date, setDate] = useState('');
  const [error, setError] = useState({ showError: false, message: '' });

  const submit = e => {
    e.preventDefault();
    setError({ ...error, showError: false });
  
    const inputCheck = { ...checkDate(date) };

    if (inputCheck.passed) {
      onSubmit(date);
    } else {
      setError({ showError: true, message: inputCheck.message });
    }
  };

  return (
    <div className={styles.calendar}>
      <form 
        onSubmit={submit}
        className="form"
      >
        <div className={styles.field}>
          <InputField
            type='text'
            placeholder={MENU.DATE_NAVIGATOR.PLACEHOLDER}
            value={date}
            name={'date'}
            onChange={e => setDate(e.target.value)}
            autoComplete="off"
            required
          />
          <ClickElement
            primary
            ElementType='button'
            type='submit'
            text={MENU.DATE_NAVIGATOR.BUTTON_TEXT}
          />          
        </div>
        {error.showError && <p style={{ color: 'tomato' }}>{error.message}</p>}
      </form>
    </div>
  );
};